export default "__VITE_ASSET__f5db11d9__"